// extracted by mini-css-extract-plugin
export default {"tooltip":"IQ-z","arrow":"JQ-z"};